(function () {
  const arrowPrev =
    '<svg class="collaborators-pagination__arrow" width="7" height="13" viewBox="0 0 7 13" fill="none" aria-hidden="true"><path d="M5.48167 11.31L1.135 6.96333C0.621667 6.45 0.621667 5.61 1.135 5.09667L5.48167 0.75" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const arrowNext =
    '<svg class="collaborators-pagination__arrow" width="7" height="13" viewBox="0 0 7 13" fill="none" aria-hidden="true"><path d="M0.75 11.31L5.09667 6.96333C5.61 6.45 5.61 5.61 5.09667 5.09667L0.75 0.75" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function pageUrl(page) {
    const url = new URL(window.location.href);
    if (page <= 1) {
      url.searchParams.delete('page');
    } else {
      url.searchParams.set('page', String(page));
    }
    return url.pathname + url.search;
  }

  function itemButton(html, className, page, disabled) {
    const tag = disabled || className.indexOf('is-current') !== -1 || className.indexOf('ellipsis') !== -1 ? 'span' : 'a';
    const el = document.createElement(tag);
    el.className = 'collaborators-pagination__item' + (className ? ' ' + className : '');
    el.innerHTML = html;
    if (tag === 'a') {
      el.href = pageUrl(page);
      el.dataset.page = String(page);
    }
    if (className.indexOf('is-current') !== -1) {
      el.setAttribute('aria-current', 'page');
    }
    if (className.indexOf('is-disabled') !== -1) {
      el.setAttribute('aria-hidden', 'true');
    }
    return el;
  }

  function desktopPages(current, total) {
    const pages = [];
    const secondLast = total - 1;
    let prevShown = 0;

    for (let i = 1; i <= total; i += 1) {
      let show = total <= 6 || i === 1 || i >= secondLast;
      if (i === 2 && current >= secondLast) show = true;
      if (current <= 3 && i <= 3) show = true;
      if (i >= current - 1 && i <= current + 1) show = true;

      if (!show) continue;
      if (prevShown > 0 && i > prevShown + 1) pages.push('ellipsis');
      pages.push(i);
      prevShown = i;
    }

    return pages;
  }

  function mobilePages(current, total) {
    const pages = [1];
    if (total >= 2) pages.push(2);
    if (total > 3) pages.push('ellipsis');
    if (total > 2) pages.push(total);
    return pages;
  }

  function renderNav(nav, current, total, mobile) {
    nav.replaceChildren();

    if (current > 1) {
      const prev = itemButton(arrowPrev, '', current - 1);
      prev.setAttribute('aria-label', 'Previous');
      nav.appendChild(prev);
    } else {
      nav.appendChild(itemButton(arrowPrev, 'is-disabled', 1, true));
    }

    const pages = mobile ? mobilePages(current, total) : desktopPages(current, total);
    pages.forEach((entry) => {
      if (entry === 'ellipsis') {
        nav.appendChild(itemButton('...', 'collaborators-pagination__ellipsis', 0, true));
        return;
      }
      if (entry === current) {
        nav.appendChild(itemButton(String(entry), 'is-current', entry, true));
      } else {
        nav.appendChild(itemButton(String(entry), '', entry));
      }
    });

    if (current < total) {
      const next = itemButton(arrowNext, '', current + 1);
      next.setAttribute('aria-label', 'Next');
      nav.appendChild(next);
    } else {
      nav.appendChild(itemButton(arrowNext, 'is-disabled', total, true));
    }
  }

  function init(root) {
    if (root.dataset.designMode === 'true') return;

    const cards = Array.from(root.querySelectorAll('.collaborators-card'));
    const perPage = Math.max(1, parseInt(root.dataset.perPage, 10) || 6);
    const totalPages = Math.ceil(cards.length / perPage);
    const desktopNav = root.querySelector('[data-collaborators-pagination="desktop"]');
    const mobileNav = root.querySelector('[data-collaborators-pagination="mobile"]');
    const list = root.querySelector('.collaborators-list');

    if (totalPages <= 1) {
      if (desktopNav) desktopNav.hidden = true;
      if (mobileNav) mobileNav.hidden = true;
      return;
    }

    function currentFromUrl() {
      const page = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
      if (Number.isNaN(page) || page < 1) return 1;
      return Math.min(page, totalPages);
    }

    function showPage(page, push) {
      const start = (page - 1) * perPage;
      const end = start + perPage;
      cards.forEach((card, index) => {
        card.hidden = index < start || index >= end;
      });

      if (desktopNav) {
        desktopNav.hidden = false;
        renderNav(desktopNav, page, totalPages, false);
      }
      if (mobileNav) {
        mobileNav.hidden = false;
        renderNav(mobileNav, page, totalPages, true);
      }

      if (push) {
        window.history.pushState({ collaboratorsPage: page }, '', pageUrl(page));
        if (list) {
          list.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    function onClick(event) {
      const link = event.target.closest('a[data-page]');
      if (!link || !root.contains(link)) return;
      event.preventDefault();
      showPage(parseInt(link.dataset.page, 10), true);
    }

    root.addEventListener('click', onClick);
    window.addEventListener('popstate', () => showPage(currentFromUrl(), false));
    showPage(currentFromUrl(), false);
  }

  document.querySelectorAll('[data-collaborators-section]').forEach(init);
})();
